<template>
  <div class="activeCalendar">
    <div class="header">
      <div class="title">
        {{$t('home.coe')}}
      </div>
      <div class="explain">
        <span>
          <i />
          {{$t('home.ra')}}
        </span>
        <span>
          <i />
          {{$t('home.ha')}}
        </span>
      </div>
      <!--<div class="currentDate">{{ currentDate }}</div>-->
    </div>
    <div class="content">
      <div class="calendar">
        <div class="dateController">
          <i class="iconfont icon-rili3-icon yearBtn" @click="yearChange(0)" />
          <i class="iconfont icon-rili4-icon monthBtn" @click="dateChange(0)" />
          <span v-if="langFlag">{{ currentYear }}年{{ currentMonth | currentMonthFilter }}月</span>
          <span v-else>{{ currentYear }} {{ monthS[currentMonth - 1] }}</span>
          <i class="iconfont icon-rili3-icon yearBtn" @click="yearChange(1)" />
          <i class="iconfont icon-rili4-icon monthBtn" @click="dateChange(1)" />
        </div>
        <commonCalendar ref="homeCalendar" @monthChange="monthChange" @clickHandle="calendarClick" :calendar-val="calendarVal" />
      </div>
      <div class="details">
        <div class="detailsContent" v-show="detailsList.length > 0">
          <ul class="content">
            <li
              v-for="(item,index) in detailsList"
              :key="index"
              :class="item.activityClassificationCode === 'AC_06' ? 'blush' : ''"
              @click="detailJump(item)"
            >
              <img src="@/assets/images/activityTypeIcon1.png" v-if="item.activityClassificationCode !== 'AC_06'">
              <img src="@/assets/images/activityTypeIcon2.png" v-else>
              <div class="activityName" :title="item.activityName">{{ item.activityName }}</div>
              <p class="applyUserName" :title="item.applyUserName">{{ item.applyUserName }}</p>
              <div class="approveStatus">{{ item.approveStatus }}</div>
            </li>
          </ul>
        </div>
        <div class="nullTips" v-show="detailsList.length < 1">
          <img src="@/assets/images/contentNull.png" alt="">
          <p>{{$t('home.empty')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonCalendar from '@/components/commonCalendar';
import '@/utils/prototypeExtension';
import { calendarApi } from '../../service';
const dayjs = require('dayjs');
export default {
  data () {
    return {
      activeDatelist: [
        {
          date: '02'
        },
        {
          date: '13'
        },
        {
          date: '15'
        }
      ],
      currentDate: '',
      currentYear: '',
      currentMonth: '',
      systemTime: {},
      currentDay: 1,
      calendarVal: [],
      detailsListAll: [],
      detailsList: [],
      detailsNullFlag: true,
      langFlag: localStorage.getItem('lang') === 'zh-CN',
      monthS: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
  },
  components: {
    commonCalendar
  },
  filters: {
    currentMonthFilter (val) {
      return val < 10 ? '0' + val : val;
    }
  },
  computed: {},
  methods: {
    monthChange (val) {
      let currentDate = new Date(
        this.currentYear,
        this.currentMonth - 1,
        1
      ).getTime();
      let selectDate = new Date(val.date).getTime();
      // 判断是加一月还是减一月
      if (selectDate > currentDate) {
        this.dateChange(1);
      } else {
        this.dateChange(0);
      }
    },
    yearChange (flag) {
      if (flag) {
        this.currentYear++;
      } else {
        this.currentYear--;
      }
      this.getCalendarList();
    },
    detailJump (item) {
      let path = '/activityDetails';
      if (item.reportType) {
        path = item.reportType === '1' ? '/regionReportDetails' : '/industryReportDetails';
      } else {
        path = item.submitType === 'report_submit' ? '/reportDetails' : '/activityDetails';
      }
      this.$router.push({
        path,
        query: {
          activityCode: item.activityCode,
          metaActive: '/home'
        }
      });
    },
    calendarClick (data) {
      const time = dayjs(data.date).format('YYYY-MM-DD');
      this.getCurrentActivityList(time);
    },
    dateChange (flage) {
      let currentDate, currentTime;
      if (flage) {
        // 获取当前月，月末，然后加一天
        currentDate = new Date(this.currentYear, this.currentMonth, 0);
        currentTime = currentDate.getTime();
        currentDate = currentTime + 24 * 60 * 60 * 1000;
      } else {
        // 获取月初 减一天
        currentDate = new Date(this.currentYear, this.currentMonth - 1);
        currentTime = currentDate.getTime();
        currentDate = currentTime - 24 * 60 * 60 * 1000;
      }
      this.currentYear = new Date(currentDate).getFullYear();
      this.currentMonth = new Date(currentDate).getMonth() + 1;
      this.detailsList = [];
      this.getCalendarList();
    },
    dateActive (data) {
      let currentDate = data.day
        .split('-')
        .splice(2, 1)
        .join();
      let activeFlag = this.activeDatelist.some(item => {
        return currentDate === item.date;
      });
      return activeFlag;
    },
    getCurrentDate () {
      // 获取当前时间 - 当前年月日周赋值
      let currentDate = new Date();
      this.currentYear = currentDate.getFullYear();
      this.currentMonth = currentDate.getMonth() + 1;
      this.currentDay = currentDate.getDate();
      let week = currentDate.getChineseWeek();
      this.currentDate = `${this.currentYear}年${this.currentMonth}月${
        this.currentDay < 10 ? '0' + this.currentDay : this.currentDay
      }日 星期${week}`;
      // 系统时间赋值
      this.systemTime = {
        systemYear: this.currentYear,
        systemMonth: this.currentMonth,
        systemDay: this.currentDay,
        systemWeek: week
      };
      // 获取日期格式的活动列表
      this.getCalendarList(this.currentDay);
    },
    getCalendarList (currentDay) {
      let startDate = `${this.currentYear}-${this.currentMonth}-01 00:00:00`;
      // let startDate = new Date(this.currentYear, this.currentMonth, 1).format('yyyy-MM-dd hh:mm:ss');
      let endDate = new Date(this.currentYear, this.currentMonth, 0).format(
        'yyyy-MM-dd hh:mm:ss'
      );
      calendarApi
        .getCalendarList({ startDate, endDate, currentDate: 'currentDate' })
        .then(res => {
          if (res.status === '200') {
            // 当前月有活动的日子
            this.calendarVal = res.data.calendar;

            // 绘制日历组件，告诉日历组件当前月有哪些日子有活动，组件绘制出对应的日历表
            this.$refs.homeCalendar && this.$refs.homeCalendar.getDateList({
              year: this.currentYear,
              month: this.currentMonth,
              day: currentDay,
              calendarVal: this.calendarVal
            });

            // 初始化获取当前日子的详情，刚进入页面获取系统时间，展示系统日子的详情列表
            // 如果当前月没有活动则结束该方法
            if (this.calendarVal.length < 1 || !currentDay) {
              return;
            }
            // 当前日子的详情(当前日子的活动列表)
            this.detailsList = res.data.activityList;
          }
          });
    },
    getCurrentActivityList (date) {
      let currentDate = '';
      if (date === 'currentDate') {
        currentDate = 'currentDate';
          } else {
        currentDate = date;
          }
      const startDate = `${this.currentYear}-${this.currentMonth}-01 00:00:00`;
      const endDate = new Date(this.currentYear, this.currentMonth, 0).format(
        'yyyy-MM-dd hh:mm:ss'
      );
      calendarApi
        .getCalendarList({ startDate, endDate, currentDate })
        .then(res => {
          if (res.status === '200') {
            this.detailsList = res.data.activityList;
        }
      });
    }
  },
  mounted () {
    this.getCurrentDate();
  }
};
</script>
<style lang="scss" scoped>
.activeCalendar {
  width: 100%;
  background: #ffffff;
  margin-top: 16px;
  > .content {
    padding-bottom: 20px;
  }
  > .header {
    padding: 16px;
    line-height: 34px;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
    > div {
      float: left;
    }
    > .title {
      font-weight: bold;
      font-size: 16px;
      color: #303133;
      margin-right: 60px;
    }
    > .explain {
      height: 34px;
      display: flex;
      float: right;
      margin-right: 20px;
      > span {
        color: #202932;
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
        > i {
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #17a58a;
          line-height: 20px;
          margin-right: 4px;
        }
      }
      > span + span {
        margin-left: 40px;
        > i {
          background: #f56c6c;
        }
      }
    }
    > .currentDate {
      color: #3384fe;
    }
  }
  > .content {
    width: 100%;
    height: 500px;
    padding: 0 16px 20px;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
    > .calendar {
      width: 50%;
      height: 100%;
      float: left;
      box-shadow: 0 2px 10px 0 rgba(63, 74, 88, 0.1);
      border-radius: 2px;
      > .dateController {
        height: 58px;
        line-height: 58px;
        text-align: center;
        padding: 0 30px;
        border-bottom: 1px solid #ebeff4;
        margin-bottom: 20px;
        > .yearBtn {
          float: left;
          margin-right: 14px;
        }
        > .yearBtn ~ .yearBtn {
          float: right;
          margin-right: 0;
          margin-left: 14px;
          transform: rotate(180deg);
        }
        > .monthBtn {
          float: left;
        }
        > .monthBtn ~ .monthBtn {
          float: right;
          transform: rotate(180deg);
        }
        > i {
          font-size: 14px;
          display: inline-block;
          color: #888888;
          &:hover {
            cursor: pointer;
          }
        }
        > span {
          font-size: 18px;
          color: #202932;
          margin: 0 26px;
        }
      }
    }
    > .details {
      width: 50%;
      height: 100%;
      float: left;
      box-sizing: border-box;
      position: relative;
      > .detailsContent {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-left: 30px;
        > .content {
          height: 100%;
          overflow-y: auto;
          padding-right: 10px;
          /*滚动条整体样式*/
          &::-webkit-scrollbar {
              width: 7px;
              height: 10px;
          }
          /*滚动条滑块*/
          &::-webkit-scrollbar-thumb {
            border-radius: 5px;
            cursor: pointer;
            background: rgba(144, 147, 153, 0.3);
            &:hover {
              background: rgba(144, 147, 153, 0.5);
            }
          }
          /*滚动条轨道*/
          &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: #ffffff;
          }
          > li {
            height: 60px;
            line-height: 60px;
            padding-right: 10px;
            cursor: pointer;
            color: #202932;
            background: #ffffff;
            position: relative;
            box-shadow: 0 2px 10px 0 rgba(63, 74, 88, 0.1);
            border-radius: 2px;
            margin-bottom: 10px;
            > img {
              width: 28px;
              position: absolute;
              top: 50%;
              left: 14px;
              transform: translateY(-50%);
            }
            > .activityName {
              margin-left: 56px;
              & {
                max-width: 200px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                @media screen and (max-width: 1440px) {
                  max-width: 180px;
                }
                @media screen and (max-width: 1350px) {
                  max-width: 180px;
                }
                @media screen and (max-width: 1260px) {
                  max-width: 160px;
                }
                @media screen and (max-width: 1140px) {
                  max-width: 100px;
                }
                @media screen and (max-width: 1010px) {
                  max-width: 80px;
                }
              }
            }
            > .approveStatus {
              width: 60px;
              height: 30px;
              line-height: 30px;
              position: absolute;
              text-align: center;
              right: 20px;
              top: 50%;
              transform: translateY(-50%);
              color: #e89127;
              background-color: #fcf0da;
              font-size: 12px;
            }
            > .applyUserName {
              width: 200px;
              height: 60px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
              color: #5b646e;
              position: absolute;
              right: 100px;
              top: 50%;
              transform: translateY(-50%);
              & {
                @media screen and (max-width: 1440px) {
                  max-width: 130px;
                }
                @media screen and (max-width: 1350px) {
                  max-width: 130px;
                }
                @media screen and (max-width: 1260px) {
                  max-width: 100px;
                }
                @media screen and (max-width: 1140px) {
                  max-width: 40px;
                }
                @media screen and (max-width: 1010px) {
                  max-width: 40px;
                }
              }
            }
          }
        }
      }
      > .nullTips {
        width: 276px;
        margin: 0 auto;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        > img {
          width: 100%;
          display: block;
          margin-bottom: 10px;
        }
        > p {
          line-height: 20px;
        }
      }
    }
  }
}
</style>
